import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";

import { Providers } from "./app/providers";
import { browserRouter } from "./app/router";
import "./styles/globals.css";

async function start() {
  // `npm run dev:mock`: the MSW worker answers for Loggione's endpoints with
  // the data of src/data/mock.ts, typed from the same OpenAPI as the client.
  if (import.meta.env.VITE_MOCK === "1") {
    const { worker } = await import("./mocks/browser");
    await worker.start({ onUnhandledRequest: "bypass" });
  }
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <Providers>
        <RouterProvider router={browserRouter()} />
      </Providers>
    </StrictMode>,
  );
}

void start();
